<template>
	<div class="relative w-full h-full" id="section_skin_intelligence">
		<!--menu  -->
		<div class="page1-menu absolute flex flex-row items-center top-[85px] w-[100%] px-[5%] z-[20] center" ref="subMenuEl">
			<div class="flex justify-evenly items-center w-full z-[99] bg-white rounded-[10px] h-[54.5px]" ref="menuNavEl">
				<div class="button text-[19px]" @click="scrollTo(2)">OUR PHILOSOPHY</div>
				<div class="button text-[19px]" @click="scrollTo(3)">SKIN INTELLIGENCE</div>
				<div class="button text-[19px]" @click="scrollTo(5)">SENSOR PROTEINS</div>
				<div class="button text-[19px]" @click="scrollTo(6)">ENHANCING SKIN INTELLIGENCE</div>
			</div>
			<img alt="" src="images/1x_images/menu-indicator.png" srcset="images/2x_images/menu-indicator.png 2x" class="absolute left-0 z-[99] will-change-transform" ref="indicatorEl" />
		</div>

		<!-- pages -->
		<div class="mainDiv1 relative flex" @scroll="handleScroll">
			<!-- <p class="fixed top-[20px] left-0 z-[999] text-[30px] p-[30px]">{{ test }}</p> -->
			<div class="parentDiv1"><Page1 ref="page1El" class="z-[21]" @loaded="loadNext(6)" @scrollTo="scrollTo" /></div>
			<div class="parentDiv1"><Page2 ref="page2El" class="z-[20]" /></div>
			<div class="parentDiv1"><Page3 ref="page3El" class="z-[19]" /></div>
			<div class="parentDiv1"><Page4 ref="page4El" class="z-[18]" /></div>
			<div class="parentDiv1"><Page5 ref="page5El" class="z-[17]" /></div>
			<div class="parentDiv1"><Page6 ref="page6El" class="z-[16]" /></div>
			<div class="parentDiv1"><Page7 ref="page7El" class="z-[15]" @next="goNext" /></div>
		</div>
		<div class="fixed bg-black bg-opacity-[0.4] rounded-[20px] bottom-[40px] flex justify-evenly items-center center w-fit z-[999] px-[10px]">
			<!-- <img alt="" src="images/arrow-left.png" srcset="images/arrow-left.png 2x" class="p-[10px]" @click="scrollTo('prev')" /> -->
			<div v-for="x in pages" :key="x" class="px-[6px] py-[12px]"><span class="block rounded-full border-[1px] border-white w-[12px] aspect-square" :style="{ backgroundColor: x == paginationCurrent ? 'white' : '' }"></span></div>
			<!-- <img alt="" src="images/arrow-right.png" srcset="images/arrow-right.png 2x" class="p-[10px]" @click="scrollTo('next')" /> -->
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import Page1 from "./page1.vue";
import Page2 from "./page2.vue";
import Page3 from "./page3.vue";
import Page4 from "./page4.vue";
import Page5 from "./page5.vue";
import Page6 from "./page6.vue";
import Page7 from "./page7.vue";
import gsap from "gsap";

export default {
	name: "main-page",
	components: { Page1, Page2, Page3, Page4, Page5, Page6, Page7 },
	data() {
		return {
			thisSection: 1,
			pages: 7,
			currentPage: 1,
			container: null,
			childDivs: null,
			inTransiting: false,
			scrollTimer: null,
			paginationCurrent: 1,
		};
	},
	watch: {
		paginationCurrent(newVal, oldVal) {
			if (oldVal == 1 && newVal > 1) {
				gsap.to(this.$refs.subMenuEl, { autoAlpha: 0.8, ease: "none", duration: 0.3, overwrite: true });
			} else if (newVal == 1) {
				gsap.to(this.$refs.subMenuEl, { autoAlpha: 0, ease: "none", duration: 0.2, overwrite: true });
			}

			if (newVal == 2) {
				this.positionIndicator(0);
			} else if (newVal == 3 || newVal == 4) {
				this.positionIndicator(1);
			} else if (newVal == 5) {
				this.positionIndicator(2);
			} else if (newVal >= 6) {
				this.positionIndicator(3);
			}
		},
	},
	methods: {
		start() {},
		stop() {},
		handleScroll(e) {
			var scrollAmount = this.container.scrollLeft;

			var calc1 = scrollAmount / 1024;
			var calc2 = Math.floor(calc1);
			var calc3 = calc1 - calc2;

			if (calc3 > 0.5) {
				this.paginationCurrent = calc2 + 2;
			} else {
				this.paginationCurrent = calc2 + 1;
			}

			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
			this.scrollTimer = setTimeout(() => this.onScrollStop(), 20);
		},
		scrollTo(page) {
			this.container.scrollTo({ left: 1024 * (page - 1), behavior: "smooth" });
		},
		onScrollStop() {
			// console.log("onScrollStop", this.container.scrollLeft);
			var that = this;
			if (currentSection != this.thisSection) return;

			for (var i = 0; i < this.childDivs.length; i++) {
				const page = this.childDivs[i];
				const rect = page.getBoundingClientRect();
				// console.log(`page${i}`, rect);
				if (Math.floor(Math.abs(rect.left)) <= 10) {
					var nextPage = page.getAttribute("page");
					console.log("nextpage", nextPage);
					// console.log("onScrollStop, nextPage ", nextPage);
					if (nextPage != that.currentPage) {
						// this.$refs[`page${that.currentPage}El`].stop();
						that.stopOthers(Number(that.currentPage));
						that.startPage(nextPage);
						that.currentPage = nextPage;
					}
				}
			}
		},
		stopOthers(page) {
			// console.log("stopOthers", this.$refs[`page${page}El`]);
			this.$refs[`page${page}El`].stop();
		},
		startPage(page) {
			this.$refs[`page${page}El`].start();
		},
		stopAll() {
			for (var i = 1; i <= 7; i++) {
				console.log("Section 1 Stop ", i);
				this.$refs[`page${i}El`].stop();
			}
			this.currentPage = 1;
		},
		resetScroll() {
			this.scrollTo(1);
			gsap.to(this.$refs.subMenuEl, { autoAlpha: 0, ease: "none", duration: 0.2, overwrite: true });
		},
		goNext(e) {
			this.$emit("next", 2);
		},
		positionIndicator(index) {
			const el = this.$refs.menuNavEl.children[index];
			const dimension = el.getBoundingClientRect();
			// console.log(dimension);

			const dimensionWidth = dimension.width / ratioToOriginal;
			const dimensionX = dimension.x / ratioToOriginal;

			var pos = (dimensionWidth - 83) / 2 + dimensionX; //83 is indicator length
			gsap.to(this.$refs.indicatorEl, { x: pos, ease: "none", duration: 0.1, overwrite: true });
		},
		loadNext(page) {
			this.$refs[`page${page}El`].setLoadVideo();
		},
	},
	mounted() {
		// var firstPage = document.querySelectorAll(".childDiv1")[this.currentPage - 1];
		// gsap.set(".childDiv1", { x: -512 });
		// gsap.set(firstPage, { x: 0 });
		this.container = document.querySelector(".mainDiv1");
		this.childDivs = document.querySelectorAll(".childDiv1");
		// this.$refs.page3El.start();

		this.$nextTick(() => {
			gsap.set(this.$refs.subMenuEl, { autoAlpha: 0, overwrite: true });
			this.positionIndicator(0);
		});
	},
};
</script>

<style></style>
